<template>
  <div>
    <div class="remoteController-operations">
      <div>
        <a-button
          v-if="$hasPermissions(['rcs:remote_controller:create'])"
          type="primary"
          class="add-btn"
          @click="jumpToCreate()"
        >
          新增
        </a-button>
      </div>
      <div
        v-if="filterRemoteRelDtos"
        class="data-filter"
      >
        <a-select
          v-model="deviceTypeSelect"
          allow-clear
          placeholder="设备类型"
          style="width: 120px"
        >
          <a-select-option
            v-for="deviceType in deviceTypeList"
            :key="deviceType.deviceTypeId"
          >
            {{ deviceType.name }}
          </a-select-option>
        </a-select>
        <a-select
          v-if="remoteRelDtosSelected"
          :default-value="remoteRelDtosSelected.value"
          style="width: 120px"
          @change="remoteChange"
        >
          <template #suffixIcon>
            <a-icon type="down" />
          </template>
          <a-select-option
            v-for="remote in filterRemoteRelDtos"
            :key="remote.value"
          >
            {{ remote.label }}
          </a-select-option>
        </a-select>
        <a-select
          v-if="remoteRelDtosSelected === $constRepository.remoteController.FILTER_OPTION_REMOTE_BRAND"
          v-model="brandSelect"
          allow-clear
          placeholder="品牌"
          style="width: 120px"
          show-search
          label-in-value
        >
          <a-select-option
            v-for="brand in brandList"
            :key="`${brand.brandId}-${brand.name}`"
          >
            {{ brand.name }}
          </a-select-option>
        </a-select>
        <a-select
          v-if="remoteRelDtosSelected === $constRepository.remoteController.FILTER_OPTION_REMOTE_PROVIDER"
          v-model="providerSelect"
          allow-clear
          placeholder="服务商"
          style="width: 120px"
          show-search
          label-in-value
        >
          <a-select-option
            v-for="provider in providerList"
            :key="`${provider.serviceProviderId}-${provider.name}`"
          >
            {{ provider.name }}
          </a-select-option>
        </a-select>
        <a-select
          v-if="remoteRelDtosSelected === $constRepository.remoteController.FILTER_OPTION_REMOTE_PLATFORM"
          v-model="platformTypeSelect"
          allow-clear
          placeholder="平台来源"
          style="width: 120px"
        >
          <a-select-option
            v-for="option in $constRepository.remoteController.PLATFORM_TYPE_OPTIONS"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </a-select-option>
        </a-select>
        <a-select
          v-if="filterSelected"
          v-model="filterSelected"
          style="width: 120px"
        >
          <template #suffixIcon>
            <a-icon type="down" />
          </template>
          <a-select-option
            v-for="select in filterOptions"
            :key="select.value"
            :value="select.value"
          >
            {{ select.label }}
          </a-select-option>
        </a-select>
        <a-input
          v-model="searchKeyword"
          placeholder
          style="width: 120px"
          @keyup.enter.native="doSearch"
        />
        <a-button
          type="primary"
          @click="doSearch"
        >
          搜索
        </a-button>
      </div>
    </div>
    <a-table
      class="remoteController-table"
      bordered
      :data-source="remoteControllerList"
      row-key="remoteControllerId"
      :pagination="false"
    >
      <a-table-column
        key="remoteControllerId"
        title="码库id"
      >
        <template #default="scope">
          <div>{{ scope.remoteControllerId }}</div>
        </template>
      </a-table-column>
      <a-table-column
        key="name"
        title="码库名称"
      >
        <template #default="scope">
          <div>{{ scope.name | orNA }}</div>
        </template>
      </a-table-column>
      <a-table-column
        key="frequency"
        title="频率"
      >
        <template #default="scope">
          <div>{{ scope.frequency | orNA }}</div>
        </template>
      </a-table-column>
      <a-table-column
        key="remark"
        title="备注说明"
      >
        <template #default="scope">
          <div>{{ scope.remark | orNA }}</div>
        </template>
      </a-table-column>
      <a-table-column
        key="platformType"
        title="三方平台来源"
      >
        <template #default="scope">
          <div>{{ platformTypeLabel(scope.platformType) }}</div>
        </template>
      </a-table-column>
      <a-table-column
        key="spRemoteRelId"
        title="服务商绑定"
        width="20%"
      >
        <template #default="scope">
          <div>{{ scope.spRemoteRelDtos | getSpRemoteRels }}</div>
        </template>
      </a-table-column>
      <a-table-column
        key="brandRemoteRelId"
        title="品牌设备绑定"
        width="20%"
      >
        <template #default="scope">
          <div>{{ scope.brandRemoteRelDtos | getBrandRemoteRels }}</div>
        </template>
      </a-table-column>
      <a-table-column
        key="action"
        title="操作"
      >
        <template #default="text, record">
          <span>
            <a-button
              v-if="$hasPermissions(['rcs:remote_controller:update'])"
              class="green-btn"
              ghost
              @click="jumptoEdit(record)"
            >编辑</a-button>
            <a-divider type="vertical" />
            <a-button
              v-if="$hasPermissions(['rcs:i18n:list'])"
              class="green-btn"
              ghost
              @click="jumptoI18n(record)"
            >国际化</a-button>
            <a-divider type="vertical" />
            <a-button
              class="green-btn"
              ghost
              @click="openTestDrawer(record)"
            >测试按键</a-button>
            <a-divider type="vertical" />
            <a-button
              v-if="$hasPermissions(['rcs:remote_controller:delete'])"
              class="red-btn"
              ghost
            >
              <a-popconfirm
                ok-text="是"
                cancel-text="否"
                title="是否删除码库?"
                @confirm="() => onDelete(record)"
              >
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </a-button>
          </span>
        </template>
      </a-table-column>
    </a-table>
    <div class="pagination">
      <a-pagination
        :current="pageInfo.page"
        :show-total="(total) => `共 ${pageInfo.totalElements} 条`"
        show-quick-jumper
        show-size-changer
        :total="pageInfo.totalElements"
        :page-size-options="['10', '20', '30', '40']"
        @showSizeChange="onShowSizeChange"
        @change="onChange"
      />
      <br>
    </div>
    <TestKeyDrawer
      :visible="testDrawerVisible"
      :loading="testDrawerLoading"
      :drawer-data="testDrawerData"
      @close="testDrawerVisible = false"
    />
  </div>
</template>

<script>
import lodash from 'lodash'
import TestKeyDrawer from './components/TestKeyDrawer.vue'

export default {
  name: 'RemoteControllerList',
  components: {
    TestKeyDrawer,
  },
  filters: {
    getBrandRemoteRels(brandRemoteRels) {
      if (!brandRemoteRels)
        return '/'

      return brandRemoteRels
        .map((brand) => {
          const brandName = (brand.brand?.name || '').toString()
          const deviceType = (brand.deviceType?.name || '').toString()
          const result = brandName && deviceType ? `${brandName}-${deviceType}` : brandName || deviceType || '/'
          return result
        })
        .toString()
    },
    getSpRemoteRels(spRemoteRels) {
      if (spRemoteRels && spRemoteRels.find(service => service.serviceProvider))
        return spRemoteRels.map(service => service.serviceProvider.name).toString()

      return '/'
    },
  },
  data() {
    return {
      brandSelect: undefined,
      providerSelect: undefined,
      deviceTypeSelect: undefined,
      platformTypeSelect: undefined,
      remoteList: undefined,
      brandList: undefined,
      providerList: undefined,
      deviceTypeList: undefined,
      searchKeyword: '',
      requestParams: {},
      filterSelected: this.$constRepository.remoteController.FILTER_OPTION_REMOTE_ID.value,
      filterOptions: [this.$constRepository.remoteController.FILTER_OPTION_REMOTE_ID, this.$constRepository.remoteController.FILTER_OPTION_REMOTE_NAME, this.$constRepository.remoteController.FILTER_OPTION_REMOTE_PLATFORM_USER_ID],
      remoteRelDtosSelected: this.$constRepository.remoteController.FILTER_OPTION_REMOTE_BRAND,
      filterRemoteRelDtos: [
        this.$constRepository.remoteController.FILTER_OPTION_REMOTE_BRAND,
        this.$constRepository.remoteController.FILTER_OPTION_REMOTE_PROVIDER,
        this.$constRepository.remoteController.FILTER_OPTION_REMOTE_PLATFORM,
      ],
      remoteControllerList: undefined,
      testDrawerVisible: false,
      testDrawerLoading: false,
      testDrawerData: {},
      pageInfo: {
        page: 1,
        size: 10,
        totalElements: 0,
        totalPages: 0,
      },
    }
  },
  activated() {
    this.loadedPageData()
    this.getBrands()
    this.getProvider()
    this.getDeviceType()
  },
  methods: {
    processSearchKeyword() {
      this.$set(this.requestParams, 'name', undefined)
      this.$set(this.requestParams, 'remoteControllerId', undefined)
      this.$set(this.requestParams, 'platformUserId', undefined)
      switch (this.filterSelected) {
        case this.$constRepository.remoteController.FILTER_OPTION_REMOTE_NAME.value:
          this.$set(this.requestParams, 'name', this.searchKeyword)
          break
        case this.$constRepository.remoteController.FILTER_OPTION_REMOTE_ID.value:
          this.$set(this.requestParams, 'remoteControllerId', this.searchKeyword)
          break
        case this.$constRepository.remoteController.FILTER_OPTION_REMOTE_PLATFORM_USER_ID.value:
          this.$set(this.requestParams, 'platformUserId', this.searchKeyword || undefined)
          break
        default:
          break
      }
    },
    doSearch() {
      this.pageInfo.page = 1
      this.loadedPageData()
    },
    async loadedPageData() {
      this.processSearchKeyword()
      await this.listRemoteController()
      if (this.pageInfo.currentPage + 1 > this.pageInfo.totalPages && this.pageInfo.currentPage) {
        this.pageInfo.page = 1
        await this.listRemoteController(this.requestParams.name, this.pageInfo)
      }
    },
    async listRemoteController() {
      const params = {
        name: this.requestParams.name,
        remoteControllerId: this.requestParams.remoteControllerId,
        deviceTypeId: this.deviceTypeSelect,
        brandId: '',
        serviceProviderId: '',
        platformType: this.platformTypeSelect,
        platformUserId: this.requestParams.platformUserId,
        page: this.pageInfo.page - 1,
        size: this.pageInfo.size,
      }
      if (this.brandSelect)
        params.brandId = lodash.split(this.brandSelect.key, '-', 2)[0]

      if (this.providerSelect)
        params.serviceProviderId = lodash.split(this.providerSelect.key, '-', 2)[0]

      const response = await this.$apiManager.remoteControllers.getRemoteController(params)
      this.remoteControllerList = response.data.elements
      this.$set(this.pageInfo, 'totalElements', response.data.totalElements)
      this.$set(this.pageInfo, 'totalPages', response.data.totalPages)
      this.$set(this.pageInfo, 'currentPage', response.data.currentPage)
    },
    remoteChange(value) {
      this.brandSelect = undefined
      this.providerSelect = undefined
      this.platformTypeSelect = undefined
      this.filterRemoteRelDtos.forEach((remote) => {
        if (remote.value === value)
          this.remoteRelDtosSelected = remote
      })
    },
    platformTypeLabel(platformType) {
      return this.$constRepository.remoteController.PLATFORM_TYPE_LABEL_MAP[platformType] || '/'
    },
    getBrands() {
      this.remoteList = null
      this.$apiManager.brand.getBrands({ unpaged: true }).then((response) => {
        this.brandList = response.data.elements
      })
    },
    getProvider() {
      this.remoteList = null
      this.$apiManager.serviceProvider.getServiceProviders({ unpaged: true }).then((response) => {
        this.providerList = response.data.elements
      })
    },
    getDeviceType() {
      this.$apiManager.deviceType.getDeviceTypes({ unpaged: true }).then((response) => {
        this.deviceTypeList = response.data.elements
      })
    },
    jumpToCreate() {
      this.$router.push({ name: 'remoteControllerCreator' })
    },
    jumptoEdit(info) {
      this.$router.push({ name: 'remoteControllerEdit', params: { remoteController: info } })
    },
    jumptoI18n(info) {
      this.$router.push({ name: 'remoteControllerI18n', params: { remoteController: info } })
    },
    async openTestDrawer(record) {
      this.testDrawerVisible = true
      this.testDrawerLoading = true
      this.testDrawerData = {}
      try {
        const response = await this.$apiManager.remoteControllers.testRemoteController(record.remoteControllerId)
        if (response.data && response.data.length)
          this.testDrawerData = response.data[0]
      }
      finally {
        this.testDrawerLoading = false
      }
    },
    async onDelete(remoteController) {
      await this.$apiManager.remoteControllers.deleteRemoteController(remoteController.remoteControllerId)
      if (this.remoteControllerList.length === 1 && this.pageInfo.page !== 1)
        this.pageInfo.page -= 1

      this.loadedPageData()
    },
    onShowSizeChange(current, pageSize) {
      this.pageInfo.page = 1
      this.$set(this.pageInfo, 'size', pageSize)
      this.loadedPageData()
    },
    onChange(pageNumber) {
      this.$set(this.pageInfo, 'page', pageNumber)
      this.loadedPageData()
    },
  },
}
</script>

<style lang="less" scoped>
.remoteController-operations {
  display: flex;
  justify-content: space-between;
  .add-btn {
    // margin: 10px 0px;
    margin-left: 3%;
  }
  .data-filter {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

}
.remoteController-table {
    margin-top: 1%;
  }
.pagination {
  margin-top: 3%;
}
.green-btn {
  color: green;
  border: none;
}
.red-btn {
  color: red;
  border: none;
}
</style>
